import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, Button, InputBase } from "@mui/material";
import { styled } from "@mui/system";
import {
  getSellerTabPost,
  handleBookmarkPost,
  handleLikePost,
} from "../../appStore/actions/ArkchatGroup/action";
import PostCard from "../post/commonComponent/PostCard/PostCard";
import { serviceTypeName, serviceTypeValue } from "../../utils/constant";
import ExploreView from "../explore/ExploreView";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import LoadingSpinner from "../../common/LoadingSpinner/LoadingSpinner";
import { getServiceCategory } from "../../appStore/actions/masterData/masterDataAction";
import { handleSavePreviewEditPostData, handleSetserviceTypePost } from "../../appStore/actions/AppState/action";
import { useNavigate } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

const SearchBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  boxSizing: "border-box",
});

const IconButtonBox = styled(Button)({
  minWidth: "30px",
  maxWidth: "30px",
  width: "30px",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  padding: "4px",
  borderRadius: "0.15rem",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  color: "#111111",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
});

const actionIconSx = {
  width: "16px",
  height: "16px",
  color: "#000000",
  flexShrink: 0,
};

const MarketPlaceViewList = ({
  setSellerTabLoading,
  isSellerTabLoading,
  isSideBarOpen,
  setSideBarOpen,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [isBookMarkedPost, setBookMarkedPost] = useState(false);
  const sellerPostList = useSelector(
    (state) => state?.arkchatgroup?.sellerPostList
  );
  const userData = useSelector((state) => state?.profile?.profileData?.data);
  const dispatch = useDispatch();
  useEffect(() => {
    setSellerTabLoading(true);
    dispatch(getSellerTabPost()).then(() => {
      setSellerTabLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLikeClick = (post_id) => {
    dispatch(handleLikePost(post_id)).then(() => {
      dispatch(getSellerTabPost()).then(() => {
        setSellerTabLoading(false);
      });
    });
  };
  const handleBookmarkClick = (post_id) => {
    dispatch(handleBookmarkPost(post_id)).then(() => {
      dispatch(
        getSellerTabPost(isBookMarkedPost ? "bookmark=true" : undefined)
      ).then(() => {
        setSellerTabLoading(false);
      });
    });
  };
  const handleGetBookMark = () => {
    const nextValue = !isBookMarkedPost;
    setBookMarkedPost(nextValue);
    setSellerTabLoading(true);
    dispatch(getSellerTabPost(nextValue ? "bookmark=true" : undefined)).then(
      () => {
        setSellerTabLoading(false);
      }
    );
  };
  const handleSidebarToggle = () => {
    setSideBarOpen((prevState) => !prevState);
  };

  const handleEditClick = (data) => {
    dispatch(handleSetserviceTypePost(data?.type));
    dispatch(getServiceCategory(data?.type));
    const createPostData = {
      category: data?.category,
      core_team: {},
      subscriber_id: data?.subscriber_id,
      tags: data?.tags || [],
      topic_id: 0,
      type: data?.type,
      countries: data?.countries || [],
      post_data: data?.postData,
      tagsInput: "",
    };
    const countriesArray = data?.countries?.map((name) => ({ name }));

    const localPreviewData = {
      selectedCategory: data?.category,
      createPostData: createPostData,
      selectedCountries: countriesArray,
      selectedImageList: data?.attachments,
      selectedVideoList: data?.attachments,
      post_id: data?.post_id,
      authorized_seller: data?.authorizedSeller,
      editBrandData: data?.brandInfo,
      editArtistData: data?.artistInfo,
    };
    dispatch(handleSavePreviewEditPostData(localPreviewData));
    localStorage.setItem("post_id", JSON.stringify(data?.id));
    let tabValue;
    if (
      data?.type === serviceTypeName?.Service ||
      data?.type === serviceTypeName?.Art ||
      data?.type === serviceTypeName?.Product
    ) {
      tabValue = 0;
    } else if (data?.type === serviceTypeName?.Photo) {
      tabValue = 1;
    } else if (data?.type === serviceTypeName?.Videos) {
      tabValue = 2;
    }
    localStorage?.setItem("tabValue", tabValue);
    navigate("/post/post-create");
  };
  return (
    <Box>
      {!userData?.tooltipMarketplaceScreenWeb && (
        <HelperScreen
          title={"How Arkchat Network works"}
          updateKey={"tooltip_marketplace_screen_web"}
          contactSections={[
            { id: "network-discover", content: [appContent?.KEY150] },
            { id: "network-listings", content: [appContent?.KEY151] },
            { id: "network-browse", content: [appContent?.KEY152] },
            { id: "network-group", content: [appContent?.KEY153] },
            { id: "network-contacts", content: [appContent?.KEY389] },
            { id: "network-free", content: [appContent?.KEY390] },
          ]}
        />
      )}

      <Stack direction="row" spacing={1}>
        <Box flex={5.2}>
          <Stack
            alignItems="center"
            direction="row"
            spacing={1.2}
            paddingX={"8px"}
            marginTop={"0.8rem"}
          >
            <IconButtonBox
              onClick={handleSidebarToggle}
              size="small"
              variant="text"
            >
              <FilterAltOutlinedIcon sx={actionIconSx} />
            </IconButtonBox>
            <SearchBar>
              <InputBase
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                placeholder="Search"
                sx={{
                  flex: 1,
                  px: 1.5,
                  fontSize: "16px",
                  color: "#000000",
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "100%",
                }}
              >
                <SearchOutlinedIcon sx={{ color: "#183243", fontSize: 20 }} />
              </Box>
            </SearchBar>
            <IconButtonBox
              onClick={handleGetBookMark}
              size="small"
              variant="text"
            >
              <BookmarkBorderOutlinedIcon sx={actionIconSx} />
            </IconButtonBox>
          </Stack>
          {isSellerTabLoading && (
            <Box>
              <LoadingSpinner />
            </Box>
          )}
          {!isSellerTabLoading && (
            <Box
              mt={"1.2rem"}
              sx={{
                maxHeight: "70vh",
                overflow: "auto",
                "&::-webkit-scrollbar": {
                  width: "0px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "3px",
                },
              }}
            >
              <>
                {sellerPostList?.posts?.length > 0 ? (
                  <>
                    <Box>
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{
                          1194: !isSideBarOpen ? 3 : 2,
                          1195: !isSideBarOpen ? 4 : 3,
                        }}
                      >
                        <Masonry gutter="0.5rem">
                          {sellerPostList?.posts?.length > 0 &&
                            sellerPostList?.posts.map((data, i) => (
                              <Box width={"100%"} key={i + "sellerPostdata"}>
                                <PostCard
                                  type={serviceTypeValue[data?.type]}
                                  postPreviewData={data}
                                  showBtn={false}
                                  sellerTab={true}
                                  handleBookmarkClick={handleBookmarkClick}
                                  handleLikeClick={handleLikeClick}
                                  handleEditClick={handleEditClick}
                                />
                              </Box>
                            ))}
                        </Masonry>
                      </ResponsiveMasonry>
                    </Box>
                  </>
                ) : (
                  <ExploreView />
                )}
              </>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default MarketPlaceViewList;
